<template>
  <v-card v-if="loading === false" width="100%">
    <v-card-title>
      {{ this.company.name }}
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col cols="12" md="6">
           <v-list dense>
            <v-list-item v-for="item in companyInformation" :key="item.label">
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.label }}</v-list-item-title>
                <v-list-item-subtitle>{{ getCompanyProperty(item.propertyName) }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
           <v-list dense>
            <v-list-item v-for="item in usageStatsInformation" :key="item.label">
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.label }}</v-list-item-title>
                <v-list-item-subtitle>{{ getUsageInfoProperty(item.propertyName) }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-chip text-color="white" :color="this.company.active ? 'green' : 'red'">
            Status kompanije: {{ this.company.active ? 'Aktivna' : 'Neaktivna' }}
          </v-chip>
          <v-chip text-color="white" :color="this.company.industry ? 'blue' : 'grey'" class="ml-2">
            Delatnost: {{ this.company.industry ? this.company.industry.name : "Nepoznato" }}
          </v-chip>
          <company-industry-selector
            :company="company"
            @updated="onIndustryUpdated"
          />
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <edit-company-dialog :company="company" @update="updateParentComponent" />
    </v-card-actions>
  </v-card>
</template>

<script>
import * as utils from '../utils.js';
import * as apiCompanies from '../api/companies.js';

import EditCompanyDialog from './EditCompanyDialog.vue';
import CompanyIndustrySelector from './IndustrySelect.vue';

export default {
  name: 'CompanyDetails',
  components: {
    EditCompanyDialog,
    CompanyIndustrySelector
  },
  data: function () {
    return {
      loading: false,
      appMode: process.env.VUE_APP_MODE,
      companyInformation: [
        { label: "PIB", propertyName: 'tid', icon: "mdi-fingerprint" },
        { label: "MB", propertyName: 'mn', icon: "mdi-fingerprint" },
        { label: "Država", propertyName: 'country', icon: "mdi-flag" },
        { label: "Grad", propertyName: 'town', icon: "mdi-city-variant" },
        { label: "Poštanski broj", propertyName: 'postalCode', icon: 'mdi-mailbox' },
        { label: "Adresa", propertyName: 'address', icon: "mdi-map-marker" },
        { label: "Datum dodavanja", propertyName: 'createdAt', icon: "mdi-calendar" },
      ],
      usageStatsInformation: [
        { label: "OS", propertyName: 'latestUsedOperatingSystem', icon: "mdi-cellphone-cog" },
        { label: "Verzija aplikacije", propertyName: 'latestUsedAppVersion', icon: "mdi-application-cog" },
      ],
      usageStats: null
    }
  },
  props: {
    company: {
      type: Object,
      required: true
    }
  },
  methods: {
    getCompanyProperty(propertyName) {
      if (propertyName === 'createdAt')
        return utils.formatDate(this.company[propertyName]);
      else
        return this.company[propertyName];
    },
    getUsageInfoProperty(propertyName) {
      if (this.usageStats === null)
        return "";
      return this.usageStats[propertyName];
    },
    updateParentComponent (companyId) {
      this.$emit('updateCompany', companyId);
    },
    getUsageStatsfromApi(companyId) {
       apiCompanies.getUsageStatsForCompany(companyId, this.$store.getters.token)
        .then(response => response.json())
        .then(responseData => {
          this.usageStats = responseData;
          this.company.latestUsedOperatingSystem = responseData.latestUsedOperatingSystem;
          this.company.latestUsedAppVersion = responseData.latestUsedAppVersion;
        })
        .catch(() => {
          console.log("Greska! Nije preuzet usage stats");
          this.usageStats = null;
        })
    },
    onIndustryUpdated(industry) {
      this.company.industry = industry;
    }
  },
  mounted() {
    this.getUsageStatsfromApi(this.company.id);
  }
}
</script>
